import React from 'react';
import { Network } from 'lucide-react';

const ServicesHero = () => {
  return (
    <section className="section-padding bg-gradient-tech text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>
      
      <div className="max-w-7xl mx-auto container-padding relative z-10">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-white/10 backdrop-blur-sm rounded-2xl mb-8 animate-fade-in">
            <Network className="w-10 h-10 text-accent" />
          </div>
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 animate-fade-in">
            Our Services
          </h1>
          
          <p className="text-xl text-blue-100 leading-relaxed animate-slide-up">
            Comprehensive IT solutions designed to transform your business. From networking 
            infrastructure to cybersecurity, we deliver excellence in every service.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServicesHero;
